import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography, Chip } from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

const DefaultCommandDisplay = ({ command }) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
       <HelpOutlineIcon fontSize="small" sx={{ color: 'text.disabled', mt: 0.5 }} />
       <Box>
        <Chip label={`Type: ${command.type || 'Unknown'}`} size="small" variant="outlined" sx={{ mb: 0.5 }}/>
        <Typography variant="body2" sx={{ color: 'text.disabled' }}>
          {typeof command.content === 'object' ? JSON.stringify(command.content) : String(command.content)}
        </Typography>
       </Box>
    </Box>
  );
};

DefaultCommandDisplay.propTypes = {
  command: PropTypes.shape({
    content: PropTypes.any,
    type: PropTypes.string,
  }).isRequired,
};

export default React.memo(DefaultCommandDisplay);